// Country dial codes for phone number input. Not tied to the app's
// business "countries" settings collection (which only lists countries
// RydeXpress currently operates in) — this is a general-purpose list so
// anyone, from any country, can enter their phone number correctly.
const countryCodes = [
  { name: "Rwanda", code: "RW", dial: "+250" },
  { name: "Kenya", code: "KE", dial: "+254" },
  { name: "Uganda", code: "UG", dial: "+256" },
  { name: "Tanzania", code: "TZ", dial: "+255" },
  { name: "Burundi", code: "BI", dial: "+257" },
  { name: "DR Congo", code: "CD", dial: "+243" },
  { name: "South Africa", code: "ZA", dial: "+27" },
  { name: "Nigeria", code: "NG", dial: "+234" },
  { name: "Ghana", code: "GH", dial: "+233" },
  { name: "Ethiopia", code: "ET", dial: "+251" },
  { name: "Egypt", code: "EG", dial: "+20" },
  { name: "Morocco", code: "MA", dial: "+212" },
  { name: "Algeria", code: "DZ", dial: "+213" },
  { name: "Tunisia", code: "TN", dial: "+216" },
  { name: "Senegal", code: "SN", dial: "+221" },
  { name: "Ivory Coast", code: "CI", dial: "+225" },
  { name: "Cameroon", code: "CM", dial: "+237" },
  { name: "Zambia", code: "ZM", dial: "+260" },
  { name: "Zimbabwe", code: "ZW", dial: "+263" },
  { name: "Malawi", code: "MW", dial: "+265" },
  { name: "Mozambique", code: "MZ", dial: "+258" },
  { name: "Botswana", code: "BW", dial: "+267" },
  { name: "Namibia", code: "NA", dial: "+264" },
  { name: "Sudan", code: "SD", dial: "+249" },
  { name: "Somalia", code: "SO", dial: "+252" },
  { name: "United States", code: "US", dial: "+1" },
  { name: "Canada", code: "CA", dial: "+1" },
  { name: "United Kingdom", code: "GB", dial: "+44" },
  { name: "France", code: "FR", dial: "+33" },
  { name: "Germany", code: "DE", dial: "+49" },
  { name: "Belgium", code: "BE", dial: "+32" },
  { name: "Netherlands", code: "NL", dial: "+31" },
  { name: "Switzerland", code: "CH", dial: "+41" },
  { name: "Italy", code: "IT", dial: "+39" },
  { name: "Spain", code: "ES", dial: "+34" },
  { name: "Portugal", code: "PT", dial: "+351" },
  { name: "Sweden", code: "SE", dial: "+46" },
  { name: "Norway", code: "NO", dial: "+47" },
  { name: "Denmark", code: "DK", dial: "+45" },
  { name: "Finland", code: "FI", dial: "+358" },
  { name: "Ireland", code: "IE", dial: "+353" },
  { name: "Poland", code: "PL", dial: "+48" },
  { name: "Austria", code: "AT", dial: "+43" },
  { name: "Greece", code: "GR", dial: "+30" },
  { name: "Turkey", code: "TR", dial: "+90" },
  { name: "Russia", code: "RU", dial: "+7" },
  { name: "Ukraine", code: "UA", dial: "+380" },
  { name: "United Arab Emirates", code: "AE", dial: "+971" },
  { name: "Saudi Arabia", code: "SA", dial: "+966" },
  { name: "Qatar", code: "QA", dial: "+974" },
  { name: "Israel", code: "IL", dial: "+972" },
  { name: "India", code: "IN", dial: "+91" },
  { name: "Pakistan", code: "PK", dial: "+92" },
  { name: "Bangladesh", code: "BD", dial: "+880" },
  { name: "China", code: "CN", dial: "+86" },
  { name: "Japan", code: "JP", dial: "+81" },
  { name: "South Korea", code: "KR", dial: "+82" },
  { name: "Singapore", code: "SG", dial: "+65" },
  { name: "Malaysia", code: "MY", dial: "+60" },
  { name: "Indonesia", code: "ID", dial: "+62" },
  { name: "Philippines", code: "PH", dial: "+63" },
  { name: "Thailand", code: "TH", dial: "+66" },
  { name: "Vietnam", code: "VN", dial: "+84" },
  { name: "Australia", code: "AU", dial: "+61" },
  { name: "New Zealand", code: "NZ", dial: "+64" },
  { name: "Brazil", code: "BR", dial: "+55" },
  { name: "Mexico", code: "MX", dial: "+52" },
  { name: "Argentina", code: "AR", dial: "+54" },
  { name: "Colombia", code: "CO", dial: "+57" },
  { name: "Chile", code: "CL", dial: "+56" },
  { name: "Peru", code: "PE", dial: "+51" },
];

export default countryCodes;
